import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import {
  AndroidIcon,
  IphoneIcon,
  GameIcon,
  FlutterIcon,
  HealthcareIcon,
  ReactIcon,
} from "../../../app-constants";
import { Link } from "gatsby";

const StackItem = [
  {
    icon: AndroidIcon,
    title: "Android App Development",
    description:
      "Grow your business to unprecedented heights with our innovative Android App Development services in Washington DC. Our customized user interface and experience can make you the next big thing in the tech market. Currently, we fuel diverse industries with flawless applications and unmatched app development solutions, guaranteeing that your digital presence is domineering.",
  },
  {
    icon: IphoneIcon,
    title: "Iphone App Development",
    description:
      "Delve into success in different business ventures with our expert iOS app development services. Yield the full potential of native iOS apps as we make use of pioneering tools like Xcode, Objective C, and Swift. Our high-performance apps generate top results, taking your business to the forefront of the competitive iOS market.",
  },
  {
    icon: GameIcon,
    title: "Game App Development",
    description:
      "You can easily rely on our game app development company utilizing AR, VR, Blockchain, and NFTs in gaming environments. Our unmatched services revolutionize your game knowledge into a global sensation. Monetize with the help of ads, sponsored content, and premium subscribers, taking advantage of new gaming arenas worldwide.",
  },
  {
    icon: FlutterIcon,
    title: "Flutter App Development",
    description:
      "Accomplish cost-efficient fineness with our Flutter app development. Create trailblazing apps well-suited with Android and iOS devices, making the most of your results without emptying the bank. Flutter’s cross-platform compatibility warrants top performance, allowing your app to prosper in the competitive digital ecosystem.",
  },
  {
    icon: HealthcareIcon,
    title: "Healthcare App Development",
    description:
      "We transform healthcare services, streamlining complex tasks for health experts. Our high-tech mobile app solutions improve workflows, permitting healthcare providers to concentrate on complex tasks. Gain a viable edge with our ground-breaking healthcare apps, designed to surpass industry standards.",
  },
  {
    icon: ReactIcon,
    title: "React Native App Development",
    description:
      "Our app developers utilize React Native to create extraordinary user interfaces with perfect performance to accomplish your business objectives. With our progressive technology and skill, we digitize operations effortlessly. Therefore, our React Native app development is a favored choice for many businesses as it guarantees your app stands out, providing a unique user experience.",
  },
];

function Improvise(props) {
  return (
    <div className="improvise_section p-100">
      <Container className="h-100">
        <Row className="h-100">
          <Col
            xs={12}
            md={10}
            lg={9}
            xl={9}
            xxl={9}
            className="m-auto text-center"
          >
            <h2>
              Leverage Our Tech-Driven App Development Services in Washington DC
            </h2>
            <p className="impro_para">
              Discover our exceptional mobile app development services in
              Washington DC, to create tailored app solutions for elevating your
              business’s digital presence. We’ve always worked with a
              future-forward mindset, where utilizing recent technologies, and
              frameworks has been our forte.
            </p>
          </Col>
          <Col xs={12} md={12} lg={12} xl={12} xxl={10} className="m-auto">
            <div className="stack_box">
              {StackItem.map((item, index) => (
                <div className="stack_item" key={index}>
                  <div className="stack_title">
                    {item.icon}
                    <h5>{item.title}</h5>
                  </div>
                  <p>{item.description}</p>
                </div>
              ))}
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Improvise;
